import React from 'react';
import VehiclesInventory from '.';

import {paths} from '../../common/dictionaries/urls';
import VehiclesByLine from './vehiclesByLine';

export const vehiclesInventoryRoutes = [
  {'component': <VehiclesInventory />, 'path': paths.VehiclesInventory},
  {'component': <VehiclesByLine />, 'path': paths.VehiclesInventoryTable},
];
